export function useCompanyDashboardSidebarLinkTitles() {
  return {
    dashboard: 'Dashboard',
    yourNetwork: 'Your network',
    yourClients: 'Your clients',
    referrals: 'Referrals',
    referralDiscovery: 'Referral discovery',
    recommendations: 'Recommendations',
    compass: 'Compass',
    integrations: 'Integrations',
  }
}
